// AUTO-GENERATED by scripts/write-version.js — do not edit.
export const buildVersion = '0.1.0.01a5b12';
